import React, { HTMLAttributes } from "react";
import * as yup from "yup";
// import { NFTApi } from "../../../api";

export interface IForm extends HTMLAttributes<HTMLFormElement> {
  /** Set input error state */
  error?: boolean;
  onSubmit?: (values?: any) => void;
  action?: string;
  onError?: () => void;
  onSuccess?: (data?: any) => void;
  onValidation?: (data?: any) => void;
  schema?: any;
}

const Form = ({
  onValidation,
  schema = yup.object().shape({}),
  action,
  onSuccess,
  onError,
  onSubmit,
  ...props
}: IForm) => {
  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (onValidation) {
      onValidation({});
    }
    const formData = new FormData(e.target);
    const object: { [key: string]: any } = {};
    formData.forEach((value, key) => {
      object[key] = value;
    });
    const json = JSON.stringify(object);
    const errors: { [key: string]: string } = {};

    schema.validate(object, { abortEarly: false }).catch((err: any) => {
      if (err.inner.length) {
        err.inner.forEach((error: any) => {
          errors[error.path] = error.message;
        });
      }
      if (Object.keys(errors)) {
        if (onValidation) {
          onValidation(errors);
        }
      }
    });
    schema.isValid(object).then((valid: boolean) => {
      if (valid) {
        if (onSubmit) {
          onSubmit(object);
          return;
        }
        if (action) {
          // NFTApi.fetchApiRequest(action, false, [])
          //   .then(() => {
          //     if (onSuccess) {
          //       onSuccess(object);
          //     }
          //   })
          //   .catch((error: Error) => {
          //     console.log(error);
          //     if (onError) {
          //       onError();
          //     }
          //   });
        }
      }
    });
  };

  return <form {...props} onSubmit={handleSubmit} />;
};

export default Form;
